import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { Terms } from './components';

import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocationV2/helpers';
import { IMarginAllocationPreviewV2 } from '@/modules/trade/services/margin-allocation';

interface IDataForm {
  balance: { formatted: string };
  drawdown: { formatted: string };
  drawdownPercentage: { formatted: string };
  isUpdatingLimits: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  setup(__props) {

const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdateLimits = inject('fetchUpdateLimits', async () => ({}));

const dataForm = inject('dataForm') as Ref<IDataForm>;

const isTermsOpen = ref(false);

const details = computed(() => {
  return [
    {
      label: 'Saldo alocado',
      value: dataForm.value.balance.formatted
    },
    {
      label: 'Prejuízo máximo',
      value: dataForm.value.drawdown.formatted
    },
    {
      label: 'Percentual do prejuízo ',
      value: dataForm.value.drawdownPercentage.formatted
    }
  ];
});

function goToPolicy() {
  window.open(marginAllocationPreview.value.policyLink, '_blank');
}

async function termAccepted() {
  isTermsOpen.value = false;
  await fetchUpdateLimits();
  changeStep(EMarginAllocationSteps.DAY_TRADE);
}

return { __sfc: true,marginAllocationPreview, changeStep, fetchUpdateLimits, dataForm, isTermsOpen, details, goToPolicy, termAccepted, HeadingDisplay, ContentDisplay, Heading, ListDisplay, ButtonContainer, ButtonPrimary, Terms }
}

})